import { AppViewMode, Client } from 'src/constants';
import { Events } from 'src/constants/webSocketConsts/events';
import { PortalConfig } from 'src/context';
import {
  handleDeletedClients,
  handleInsertedClients,
  handleModifiedClients,
} from 'src/store/clients/actions';
import { updateUsers } from 'src/store/users/actions';
import { ensureUnreachable } from 'src/utils/common_utils';
import { handleSignOut } from 'src/utils/UserUtils';

const ClientHandler = (
  event: Events,
  items: Array<Client>,
  portalConfig: PortalConfig,
  userID: string,
) => {
  switch (event) {
    case Events.Insert:
      return handleInsertedClients(items, true);
    case Events.Modify: {
      // if we are rendering for a client experience
      // then the data to be updated is in the users slice
      if (portalConfig.viewMode === AppViewMode.CLIENT) {
        return updateUsers(items);
      }

      // for internal users, we call the action from the client slice
      return handleModifiedClients(items, true);
    }
    case Events.Remove: {
      const filteredItems = items.filter((item) => item.id === userID);
      if (filteredItems && filteredItems.length > 0) {
        handleSignOut(
          portalConfig,
          Boolean(filteredItems.at(0)?.fields.isTestUser),
        );
      }
      return handleDeletedClients(items, true);
    }
    case Events.DomainVerified:
    case Events.Refresh:
      return null;
    default:
      return ensureUnreachable(event);
  }
};

export default ClientHandler;
